export const systemTypes = [
  {
    icon: "ri-dashboard-3-line",
    title: "Painéis e dashboards",
    description:
      "Visualize dados e indicadores do seu negócio em um painel claro e personalizado.",
  },
  {
    icon: "ri-team-line",
    title: "CRM e gestão de clientes",
    description:
      "Organize contatos, atendimentos e o relacionamento com os seus clientes.",
  },
  {
    icon: "ri-file-list-3-line",
    title: "Portais e áreas restritas",
    description:
      "Espaços com controle de acesso para clientes, parceiros ou equipes internas.",
  },
  {
    icon: "ri-links-line",
    title: "Integrações e APIs",
    description:
      "Conecte sistemas, automatize tarefas e centralize informações em um só lugar.",
  },
];

export const systemBenefits = [
  {
    icon: "ri-timer-flash-line",
    title: "Automação de tarefas",
    description: "Reduza processos manuais e ganhe tempo nas rotinas do dia a dia.",
  },
  {
    icon: "ri-bar-chart-2-line",
    title: "Informação centralizada",
    description: "Todos os dados importantes reunidos em um único ambiente.",
  },
  {
    icon: "ri-lock-2-line",
    title: "Acesso controlado",
    description: "Defina permissões e mantenha as informações seguras.",
  },
  {
    icon: "ri-smartphone-line",
    title: "Acesso de qualquer lugar",
    description: "Sistemas web acessíveis pelo navegador em qualquer dispositivo.",
  },
  {
    icon: "ri-line-chart-line",
    title: "Pronto para crescer",
    description: "Estrutura que evolui conforme a sua operação aumenta.",
  },
  {
    icon: "ri-customer-service-2-line",
    title: "Suporte próximo",
    description: "Acompanhamento de quem entende o seu projeto.",
  },
];

export const systemSteps = [
  {
    icon: "ri-search-eye-line",
    title: "Levantamento",
    description: "Mapeamos a sua necessidade, os processos e o que o sistema precisa resolver.",
  },
  {
    icon: "ri-draft-line",
    title: "Arquitetura",
    description: "Desenhamos as telas, os fluxos e a estrutura técnica da solução.",
  },
  {
    icon: "ri-code-s-slash-line",
    title: "Desenvolvimento",
    description: "Construímos o sistema com foco em usabilidade, segurança e desempenho.",
  },
  {
    icon: "ri-loop-right-line",
    title: "Evolução contínua",
    description: "Acompanhamos o uso e ajustamos a solução conforme a operação evolui.",
  },
];

export const sistemasFaqs = [
  {
    question: "Vocês desenvolvem sistemas personalizados?",
    answer:
      "Sim. Criamos soluções web sob medida para necessidades específicas da sua empresa, como painéis, portais, CRM e integrações.",
  },
  {
    question: "Como funciona o orçamento de um sistema?",
    answer:
      "O valor depende das funcionalidades e da complexidade do projeto. Depois do levantamento, apresentamos uma proposta alinhada ao seu escopo.",
  },
  {
    question: "O sistema funciona no celular?",
    answer:
      "Sim. As soluções web são construídas para funcionar bem em computadores, tablets e celulares.",
  },
  {
    question: "Vocês integram com sistemas que já usamos?",
    answer:
      "Sempre que possível, sim. Avaliamos as integrações necessárias para conectar o novo sistema às ferramentas que a sua empresa já utiliza.",
  },
  {
    question: "E se depois eu precisar de novas funções?",
    answer:
      "A estrutura é pensada para evoluir. Novas funcionalidades podem ser adicionadas conforme a sua operação cresce.",
  },
];